import { CpsSearchQueryRequest, CpsSearchQueryResult } from '@cs-cms/types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { searchKeys } from '../../queryKeys/search';

export function useSearch(querySearch?: CpsSearchQueryRequest): UseQueryResult<CpsSearchQueryResult, unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getSearchResults = () => {
    if (servicesCtx?.searchService && querySearch) {
      return servicesCtx.searchService.getSearchResults(querySearch);
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: searchKeys.filteredSearch(querySearch),
    queryFn: getSearchResults,
    retry: 0,
    staleTime: 180000,
    gcTime: 180000,
    enabled: !!querySearch
  });
}
